import { injectIntl } from 'react-intl';
import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import ConfigSettingsForm from '../../../components/SiteAdmin/ConfigSettingsForm/ConfigSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';

import getSiteSettings from './getSiteSettings.graphql';
import messages from '../../../locale/messages';
import s from './ConfigSettings.css';

export class ConfigSettings extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { getSiteSettings: { loading, getSiteSettings, refetch } } = this.props;
    let settingsCollection = {}

    if (!loading) {
      getSiteSettings.map((item) => {
        settingsCollection[item.name] = item.value
      });
    }

    return (
      <Loader type={"page"} show={loading} >
        <div className={s.root}>
          <div className={s.container}>
            {!loading && settingsCollection &&
              <>
                <div className={s.heading}>
                  {formatMessage(messages.configSettings)}
                </div>
                <div className={s.paddingRoutesSection}>
                  <ConfigSettingsForm refetch={refetch} getSiteSettings={getSiteSettings} initialValues={settingsCollection} />
                </div>
              </>}
          </div>
        </div>
      </Loader>
    );

  }
}


export default compose(injectIntl,
  withStyles(s),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: (props) => ({
      variables: {
        type: 'configSettings'
      },
      ssr: true,
    }),
  })
)(ConfigSettings)
